<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCogs } from "@mdi/js";
export default {
  name: "MdiCogs",
  data() {
    return {
      svgPath: mdiCogs,
    };
  },
};
</script>
